import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
const swal = require('sweetalert');
import * as moment from 'moment';
import { Cliente } from '../../../../../../models/importacao-cliente/detalhe-importacao-cliente.model';
import { LoadingService } from '../../../../../../util/loader.service';
import { ImportarClienteService } from '../../../../importa-cliente/importar-cliente.service';
import RedeSocial from '../../../../../../models/rede-social/rede-social.model';
import { RedesSociaisService } from '../redes-sociais.service';

@Component({
  selector: 'app-modal-form-rede-social',
  templateUrl: './modal-form-rede-social.component.html',
  styleUrls: ['./modal-form-rede-social.component.scss']
})
export class ModalFormRedeSocialComponent implements OnInit {

  public onClose: Subject<any>;
  valForm: FormGroup;
  record: RedeSocial;
  redes = [];

  constructor(
    private _bsModalRef: BsModalRef,
    public loader: LoadingService,
    private route: ActivatedRoute,
    fb: FormBuilder,
    public service: RedesSociaisService,
    private _localeService: BsLocaleService,
  ) {
    const urlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
    this.valForm = fb.group({
      'nome': [null, [Validators.required]],
      'url': [null, [Validators.required, Validators.pattern(urlRegex)]],
    });
    this.record = new RedeSocial();
    this._localeService.use('pt');
  }

  ngOnInit() {
    this.onClose = new Subject();
    this.service.listarRedes().subscribe(itens => {
      this.redes = itens;
    });

  }
  submitForm($ev, value: any, buttonType: string) {
    $ev.preventDefault();
    for (const c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {
      this.loader.show('body');
      debugger;
      if (this.record.id_rede_social == undefined || this.record.id_rede_social == null) {
        this.service.cadastrar(this.record).subscribe(itens => {
          this.loader.hide('body');
          if (itens === true) {
            swal('Sucesso', 'Informações salvas com sucesso.', 'success');
            this.onOk();
          }

        });
      } else {
        this.service.atualizar(this.record).subscribe(itens => {
          this.loader.hide('body');
          if (itens === true) {
            swal('Sucesso', 'Informações salvas com sucesso.', 'success');
            this.onOk();
          }

        });
      }
    }
  }
  public onCancel(): void {
    const output = {
      reload: false
    };
    this.onClose.next(output);
    this._bsModalRef.hide();
  }

  public onOk(): void {
    const output = {
      reload: true
    };
    this.onClose.next(output);
    this._bsModalRef.hide();
  }

}
